<template>
    <!-- 选择题 -->
    <div id="paper"
         v-if="!!checked">
        <div class="choose">
            <p class="title_t">
                <span v-if="ask_length>1"
                      class="num">({{question.number}})</span>
                <!-- <span class="num" v-else>{{number}}、</span> -->
                <span v-if="question.subject.content.length"
                      class="title_p"
                      v-html="question.subject.content"></span>
                <img v-if="question.subject.image.length"
                     :src="question.subject.image" />
            </p>
            <ul :class='{"inspect_myColor":myColor}'
                v-if="question.options.length>1">
                <li v-for="q in question.options"
                    v-if="question.options.length">
                    <i :class='[q.option == question.user_answer ? "i_equal" : "i_noequal"]'>{{q.option}}</i>
                    <p :class='[q.option == question.user_answer ? "p_equal" : "i_noequal"]'>
                        <span v-if="q.content"
                              v-html="q.content"></span>
                        <img :src="q.image.url || q.image"
                             v-if="q.image.url || q.image">
                    </p>
                </li>
            </ul>
            <ul class='Supervisor'
                v-else>
                <li>参考答案</li>
                <li v-for="q in question.options"
                    v-if="question.options.length">
                    <!-- <i class="i_noequal">{{q.option}}</i> -->
                    <p v-html="q.content">
                        <span v-if="q.content"
                              v-html="q.content"></span>
                        <img :src="q.image.url || q.image"
                             v-if="q.image.url || q.image">
                    </p>
                </li>
            </ul>
        </div>
    </div>
    <!-- 选择题 -->
    <div id="paper"
         v-else>
        <div class="choose">
            <p class="title_t">
                <span v-if="ask_length>1"
                      class="num">({{question.number}})</span>
                <span v-if="question.subject.content.length"
                      :class="{'title_p':ask_length>1}"
                      v-html="question.subject.content"></span>
                <img v-if="question.subject.image.length"
                     :src="question.subject.image" />
            </p>
            <!-- <div class="showBtn"
                 @click="showBtn"
                 v-if="mytask!=1">{{showBtnCon}}<i :class="{'icon_bottom':!chooseShowBtn,'icon_top':chooseShowBtn}"></i></div> -->
            <ul v-if="chooseShowBtn">
                <li v-for="q in question.options"
                    v-if="question.options.length">
                    <i :class='[q.is_right == 1 ? "i_equal" : "i_noequal"]'>{{q.option}}</i>
                    <p :class='[q.is_right == 1 ? "p_equal" : "i_noequal"]'>
                        <span v-if="q.content"
                              v-html="q.content"></span>
                        <img :src="q.image.url || q.image"
                             v-if="q.image.url || q.image">
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
// checked
export default {
    props: ['question', 'askLength', 'number', 'checked', 'mystatus', 'myColor'],
    //mystatus 1 不显示展开
    data () {
        return {
            showBtnCon: '展开选项',
            chooseShowBtn: true,
        }
    },
    components: {

    },
    computed: {
        ask_length () {
            return this.askLength ? this.askLength : 1
        },
        mytask () {
            return this.mystatus ? 1 : 0;
        }

    },
    beforeRouteLeave (to, from, next) {

    },
    methods: {
        showBtn () {
            this.chooseShowBtn = !this.chooseShowBtn;
            if (this.chooseShowBtn) {
                this.showBtnCon = '收起选项';
                this.$nextTick(function () {
                    MathJax.Hub.Typeset(document.body)
                })
            } else {
                this.showBtnCon = '展开选项';
            }
        },
    },
    created () {
        // this.$nextTick(function () {
        //              // MathJax.Hub.Typeset(document.body)
        //          })
        if (this.mytask == 1) {
            this.chooseShowBtn = true;
        }
    },
    destroyed () {

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.title_t {
    background: $c-fbg;
    padding: $w;
    line-height: 48px / $ppr;
    border-bottom: $line 1px / $ppr solid;
    position: relative;
    word-break: break-all;
    word-wrap: break-word;
    .num {
        position: absolute;
        left: 25px / $ppr;
        top: 25px / $ppr;
        // background:#aaa;
    }
    .title_p {
        width: 96%;
        display: inline-block;
        padding-left: 50px / $ppr;
        word-break: break-all;
        word-wrap: break-word;
    }
    > img {
        position: relative;
        // left:50px/$ppr;
    }
}
.Supervisor {
    color: #5e89ef;
}
.showBtn {
    border-bottom: $line 1px / $ppr solid;
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    color: #5e89ef;
    font-size: 30px / $ppr;
    padding-left: 40px / $ppr;
    position: relative;
    i {
        display: block;
        width: 25px / $ppr;
        height: 13px / $ppr;
        position: absolute;
        top: 42px / $ppr;
        left: 170px / $ppr;
    }
    .icon_bottom {
        background: url("./img/icon_open.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
    .icon_top {
        background: url("./img/icon_close.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
}
.choose {
    background: $c-fbg;
    // margin-top: $w;
    ul {
        li {
            padding: $w;
            line-height: 48px / $ppr;
            border-bottom: $line 1px / $ppr solid;
            position: relative;
            i {
                position: absolute;
                top: $w;
                left: $w;
                text-align: center;
                display: inline-block;
                width: 50px / $ppr;
                height: 50px / $ppr;
                line-height: 50px / $ppr;
                border-radius: 50%;
                &.i_equal {
                    border: #66cc22 1px / $ppr solid;
                    background: #66cc22;
                    color: #fff;
                }
                &.i_noequal {
                    border: $line 1px / $ppr solid;
                }
            }
            p {
                display: inline-block;
                width: auto;
                padding-left: 80px / $ppr;
                &.p_equal {
                    color: #66cc22;
                }
            }
        }
        &.inspect_myColor {
            i {
                &.i_equal {
                    border: #5d89ef 1px / $ppr solid;
                    background: #5d89ef;
                }
                &.i_noequal {
                    border: $line 1px / $ppr solid;
                }
            }
            p {
                &.p_equal {
                    color: #5d89ef;
                }
            }
        }
    }
    .p {
        padding: $w;
        line-height: 48px / $ppr;
        border-bottom: $line 1px / $ppr solid;
        min-height: 48px / $ppr;
    }
    position: relative;
    .taskbottom {
        line-height: $h-header;
        height: $h-header;
        padding: 0 $w;
        font-size: $lt;
        color: $c-light;
        position: relative;
        span:nth-of-type(2) {
            line-height: 50px / $ppr;
            text-align: center;
            width: 120px / $ppr;
            height: 50px / $ppr;
            position: absolute;
            top: 20px / $ppr;
            right: 20px / $ppr;
            border-radius: 50px / $ppr;
            border: 1px / $ppr solid res;
            &.Select {
                color: #5e89ef;
                border: 1px / $ppr solid #5e89ef;
            }
            &.remove {
                color: #ff6600;
                border: 1px / $ppr solid #ff6600;
            }
        }
    }
}
</style>
